export default function Template(props) {
    return <div className="NotificationTitle">Очищено нотифікації</div>
}
